module.exports = __webpack_public_path__ + "static/img/new-03.db1b51d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/new-03.jpg
// module id = W6kN
// module chunks = 0